import React from "react";
import { Backdrop, Grid, styled } from "@mui/material";
import { handleClose } from "../../../actions/common";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
	zIndex: theme.zIndex.drawer + 1,
	color: "#fff",
	".container": {
		width: "100%",
		height: "75vh",
	},
}));

const StyledImage = styled("img")(() => ({
	width: "100%",
	height: "100%",
	objectFit: "contain",
}));

const ImageBackdrop = (): JSX.Element => {
	const dispatch = useAppDispatch();

	const { selectedImage, open } = useAppSelector((state) => state.common);
	return (
		<StyledBackdrop open={open} onClick={() => dispatch(handleClose())}>
			<Grid container spacing={3} justifyContent="center" alignItems="center">
				<Grid item md={2} />
				<Grid item xs={12} md={8}>
					<div className="container">
						<StyledImage src={selectedImage} alt="Image Preview" />
					</div>
				</Grid>
				<Grid item md={2} />
			</Grid>
		</StyledBackdrop>
	);
};

export default ImageBackdrop;
